import { render, staticRenderFns } from "./ProductsFoundersCard.vue?vue&type=template&id=ae9c6706&scoped=true&"
import script from "./ProductsFoundersCard.vue?vue&type=script&lang=js&"
export * from "./ProductsFoundersCard.vue?vue&type=script&lang=js&"
import style0 from "./ProductsFoundersCard.vue?vue&type=style&index=0&id=ae9c6706&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae9c6706",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ProductsFoundersCardItemBody: require('/app/appsumo/nuxt/components/products/founders/ProductsFoundersCardItemBody.vue').default})
